import { computed, watch, onMounted, onUnmounted, unref } from 'vue'
import {
  CHALLENGE_THEMES,
  getCardThemeVars,
  getLayoutBackground,
  getShowStars,
  resolveChallengeTheme,
} from '@/modules/waiting-room/daily-meditation/config/playerThemes'

/** Flag compartido con el router: evita eliminar --layout-main-bg al navegar entre vistas con tema. */
export const challengeNavFlag = { isChallengeDestination: false }

const LAYOUT_THEME_BG_CLASS = 'has-layout-theme-bg'

/**
 * Orquesta el tema de un reto: fondo del layout, estrellas y variables CSS del card.
 *
 * @param {string | import('vue').Ref<string>} themeKey  Clave del registry (ej. 'dark', 'light')
 */
export function usePlayerTheme(themeKey) {
  const resolvedThemeKey = computed(() => resolveChallengeTheme(unref(themeKey)))

  const theme = computed(() => CHALLENGE_THEMES[resolvedThemeKey.value])
  const showStars = computed(() => getShowStars(resolvedThemeKey.value))
  const cardThemeVars = computed(() => getCardThemeVars(resolvedThemeKey.value))

  const applyBackground = (key) => {
    document.documentElement.style.setProperty('--layout-main-bg', getLayoutBackground(key))
    document.documentElement.classList.add(LAYOUT_THEME_BG_CLASS)
  }

  const clearBackground = () => {
    document.documentElement.style.removeProperty('--layout-main-bg')
    document.documentElement.classList.remove(LAYOUT_THEME_BG_CLASS)
  }

  onMounted(() => applyBackground(resolvedThemeKey.value))
  onUnmounted(() => {
    if (!challengeNavFlag.isChallengeDestination) {
      clearBackground()
    }
  })
  watch(resolvedThemeKey, applyBackground)

  return {
    theme,
    themeKey: resolvedThemeKey,
    showStars,
    cardThemeVars,
  }
}
